module.exports = __webpack_public_path__ + "static/media/cafe_owner_cat_alpha.30034008.png";